export const DOCUMENT_FILTER_FIELDS_AI = {
  externalId: 'metadata.externalId',
};

export const FILTER_TYPE = {
  document: 'document',
  media: 'media',
};
